<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch">
      <template>
        <el-button type="primary" @click="handleCreated">新增</el-button>
      </template>
    </com-search>
    <com-card>
      <com-table ref="table" :columns="columns" :api="api">
        <template #status="row">
          <el-switch
            @change="handleEditStatus(row.data)"
            v-model="row.data.status"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </template>
        <template #createdTime="row">
          <div>
            {{ row.data.createTime | formatDate }}
          </div>
        </template>
        <template #operation="row">
          <el-button type="primary" @click="handleEdit(row.data)" class="mb-5px" size="mini"
            >编辑</el-button
          >
          <el-button type="" @click="handleHistory(row.data)" class="mb-5px" size="mini"
            >开通记录</el-button
          >
          <el-button type="danger" @click="handleDel(row.data)" class="mb-5px" size="mini"
            >删除</el-button
          >
        </template>
      </com-table>
    </com-card>
    <the-add-monthly-card ref="monthlyCard" @success="handleUpdate"></the-add-monthly-card>
  </com-page>
</template>

<script>
import { list, deleteApi, updateStatus } from '@/api/monthly_card'

import theAddMonthlyCard from './components/the-add-monthly-card'

export default {
  components: { theAddMonthlyCard },
  data() {
    return {
      api: list,
      searchColumns: [
        {
          label: '月卡名称',
          type: 'input',
          prop: 'name'
        },
        {
          label: '网点',
          type: 'input',
          prop: 'StoreName'
        },
        {
          label: '状态',
          type: 'select',
          prop: 'status',
          option: [
            {
              label: '上架',
              value: 1
            },
            {
              label: '下架',
              value: 0
            }
          ]
        },
        {
          label: '创建时间',
          type: 'date',
          prop: 'date'
        }
      ],
      columns: [
        {
          label: '月卡名称',
          prop: 'name',
          minWidth: 150
        },
        {
          label: '适用网点',
          prop: 'storeName',
          minWidth: 150
        },
        {
          label: '已售数量',
          prop: 'payCount'
        },
        {
          label: '销售金额',
          prop: 'payMoney'
        },
        {
          label: '状态',
          prop: 'status',
          type: 'slot',
          slotName: 'status'
        },
        {
          label: '创建时间',
          type: 'slot',
          prop: 'createdTime',
          slotName: 'createdTime'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation',
          width: 250,
          fixed: 'right'
        }
      ]
    }
  },
  methods: {
    handleCreated() {
      const params = {
        type: 'created'
      }
      this.$refs.monthlyCard.open(params)
    },
    handleUpdate() {
      this.$refs.table.init()
    },
    async handleEditStatus(row) {
      const params = {
        code: row.code,
        status: row.status
      }

      const res = await updateStatus(params).catch(() => {
        return
      })
      if (res.status === 200) {
        this.$message.success(res.desc)
      }
      this.$refs.table.getList()
    },
    handleEdit(row) {
      const params = {
        type: 'edit',
        code: row.code
      }
      this.$refs.monthlyCard.open(params)
    },
    handleDel(row) {
      this.$confirm('是否确认删除选项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            code: row.code
          }
          deleteApi(params).then((res) => {
            const { desc } = res
            this.$message.success(desc)
            this.handleUpdate()
          })
        })
        .catch(() => {})
    },
    handleSearch(opt) {
      if (opt.beginTime) {
        opt.startTime = opt.beginTime
      }
      delete opt.beginTime
      this.$refs.table.search(opt)
      console.log('opt :>> ', opt)
    },
    // 开通记录
    handleHistory(row) {
      console.log('row :>> ', row)
      // const params = {
      //   name: row.name
      // }
      this.$router.push({ name: 'monthly_card-records', params: { name: row.name } })
    }
  }
}
</script>

<style lang="scss" scoped></style>
